module.exports = __webpack_public_path__ + "img/other_sale_infographic.277dab1b.svg";